import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../utils/apiActions/dashboardApi";

const useAxios = () => {
  const navigate = useNavigate();
  const axiosInstance = axios.create({
    baseURL: baseUrl,
  });

  const getJwtExpirationDate = (token) => {
    try {
      const decodedToken = jwtDecode(token);
      return new Date(decodedToken.exp * 1000);
    } catch (error) {
      console.error("Invalid token", error);
      return null;
    }
  };

  axiosInstance.interceptors.request.use(
    (config) => {
      const user = JSON.parse(localStorage.getItem("user"));
      const { access_token } = user || {};

      if (access_token) {
        const expirationDate = getJwtExpirationDate(access_token);

        if (expirationDate && expirationDate < new Date()) {
          // Token is expired
          localStorage.setItem(
            "redirectPath",
            window.location.pathname + window.location.search
          );
          localStorage.removeItem("user"); // Remove the expired token
          alert("Session Expired, login again")
          navigate("/"); // Redirect to the login page
          return Promise.reject(new Error("Token expired"));
        }

        // Token is valid, attach it to the request
        config.headers.Authorization = `Bearer ${access_token}`;
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export default useAxios;
